/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";

export class KitchenDramaSushiManiaGameAssets {

    static BITMAP_FONT_OPENSANS_800 = "NumbersOpenSans800";
    static BITMAP_FONT_WIN_COUNT_UP = "komika-bm-monospaced";

    public static MAIN_GAME_BACKGROUND:string = "mainBackground";
    public static FS_BACKGROUND:string = "freespinBackground";


    public static COLLECTABLE_TEST_PLATE:string = "testPLate";
    static CHOP_STICKS_DECOR:string = "transition/sticks";
    static KAMISABI_LOGO:string = "kamisabiLogo";
    static SUSHI_LOGO:string = "sushiLogo";

    static LOGO:string = "background/sushimania_logo";




    static KAMISABI_BACKGROUND_ANIMATION:string = "kamisabiBackgroundAnimation";
    static KAMISABI_TEXT_ANIMATION:string = "kamisabiTextAnimation";
    static KAMISABI_ANIMATION_KA:string = "kamisabiAnimationKa";
    static KAMISABI_ANIMATION_MI:string = "kamisabiAnimationMi";
    static KAMISABI_ANIMATION_SABI:string = "kamisabiAnimationSabi";

    public static KAMISABI_MID_MELT:string = "KAMISABI_MID_MELT";
    public static KAMISABI_LOW_MELT:string = "KAMISABI_LOW_MELT";
    public static KAMISABI_MAYO_MELT:string = "KAMISABI_MAYO_MELT";
    public static KAMISABI_SPLASH:string = "KAMISABI_SPLASH";


    public static BLACK_HOLE_ANIMATION:string = "blackHole";
    static WIN_PARTICLE:string = "particles/particle";

    static KAMISABI_SHADOW:string = "kamisabi/kamisabi-shadow";
    static KAMISABI_FLY:string = "kamisabi/meteor_on_reel";
    public static FS_NUMBER_ANIM:string = "ten_fs";
    public static BANNER_LEFT:string = "BANNER_LEFT";
    public static BANNER_RIGHT:string = "BANNER_RIGHT";




    static FS_SUSHI_SALMON_NO_LEGS:string = "freespin/salmonNoLegs";
    static FS_SUSHI_SALMON_NO_LEGS_MINI:string = "freespin/salmonNoLegsMini";
    static FS_SUSHI_SOY_NO_LEGS:string = "freespin/soyNoLegs";
    static FS_SUSHI_SOY_NO_LEGS_MINI:string = "freespin/soyNoLegsMini";
    static FS_SUSHI_RICE_NO_LEGS:string = "freespin/riceNoLegs";
    static FS_SUSHI_RICE_NO_LEGS_MINI:string = "freespin/riceNoLegsMini";
    static FS_SUSHI_METER_ARROW:string = "freespin/arrow";
    static FS_SUSHI_METER_FILL:string = "freespin/meterFill";
    static FS_SUSHI_METER_FILL_WHITE:string = "freespin/meterFillWhite";
    static FS_SUSHI_METER_BACK_PLATE:string = "freespin/meterBackPlate";
    static FS_SUSHI_METER_LOGO:string = "freespin/sushi-meter-sign";
    static FS_SUSHI_METER_ATTENTION:string = "freespin/fsSushiMeterAttention";
    static FS_SUSHI_METER_TRANSFORM_SYMBOL:string = "freespin/sushi-transform-meter";

    static SMOKE:string = "smoke";





    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if (stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "" + stateName;
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro:[],

        main:[
            {
                autoLoad:[AssetQualityLevel.HIGH],
                name:"fonts",
                assets:[
                    new BitmapFontAsset(KitchenDramaSushiManiaGameAssets.BITMAP_FONT_OPENSANS_800, "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset(KitchenDramaSushiManiaGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/komika-bm-monospaced.fnt"),
                ]
            },
            {
                autoLoad:[AssetQualityLevel.HIGH],
                name:"backgrounds",
                assets:[
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json")
                ]
            },
            {
                autoLoad:[AssetQualityLevel.HIGH],
                name:"main",
                assets:[
                    new TextureAsset("main0", "sheets/main/main0.json")
                ]
            },
            {
                autoLoad:[AssetQualityLevel.HIGH],
                name:"mainJpeg",
                assets:[
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json")
                ]
            },
            {
                autoLoad:[AssetQualityLevel.HIGH],
                name:"symbols",
                assets:[
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations:{}
            },
            {
                autoLoad:[AssetQualityLevel.HIGH],
                name:"animationSheets",
                assets:[
                    new TextureAsset("L1_jump_base", "sheets/animationSheets/jump/L1_jump.json"),
                    new TextureAsset("L2_jump_base", "sheets/animationSheets/jump/L2_jump.json"),
                    new TextureAsset("L3_jump_base", "sheets/animationSheets/jump/L3_jump.json"),
                    new TextureAsset("L4_jump_base", "sheets/animationSheets/jump/L4_jump.json"),
                    new TextureAsset("M1_jump_base", "sheets/animationSheets/jump/M1_jump.json"),
                    new TextureAsset("M2_jump_base", "sheets/animationSheets/jump/M2_jump.json"),
                    new TextureAsset("M3_jump_base", "sheets/animationSheets/jump/M3_jump.json"),
                    new TextureAsset("M4_jump_base", "sheets/animationSheets/jump/M4_jump.json"),
                    new TextureAsset("W_jump_base", "sheets/animationSheets/jump/W_jump.json"),
                    new TextureAsset("W2_jump_base", "sheets/animationSheets/jump/W2_jump.json"),
                    new TextureAsset("WSushi_jump_base", "sheets/animationSheets/jump/WSushi_jump.json"),

                    new TextureAsset("char1-melt_base", "sheets/animationSheets/kamisabi/char1-melt.json"),
                    new TextureAsset("lowsym-melt_base", "sheets/animationSheets/kamisabi/lowsym-melt.json"),
                    new TextureAsset("mayo-melt_base", "sheets/animationSheets/kamisabi/mayo-melt.json"),
                    new TextureAsset("splash_base", "sheets/animationSheets/kamisabi/splash.json"),

                    new TextureAsset("klink_base", "sheets/animationSheets/swoosh/klink.json"),
                    new TextureAsset("swoosh_1_base", "sheets/animationSheets/swoosh/swoosh.s1.json"),
                    new TextureAsset("swoosh_2_base", "sheets/animationSheets/swoosh/swoosh.s2.json"),
                    new TextureAsset("swoosh_3_base", "sheets/animationSheets/swoosh/swoosh.s3.json"),
                    new TextureAsset("swoosh_4_base", "sheets/animationSheets/swoosh/swoosh.s4.json"),

                    new TextureAsset("bw_base", "sheets/animationSheets/big-win/bw-intro.json"),
                    new TextureAsset("bwNextLvl_base", "sheets/animationSheets/big-win/bw-nextlvl.json"),


                    new TextureAsset("sushi_collect-logo-animbase", "sheets/animationSheets/collect/sushi_collect-logo-anim.json"),

                    new TextureAsset("collect-all-glimmer_base", "sheets/animationSheets/collect/collect-all-glimmer.json"),

                    new TextureAsset("collect-rice-reset_base", "sheets/animationSheets/collect/collect-rice_reset.json"),
                    new TextureAsset("collect-rice-win_base", "sheets/animationSheets/collect/collect-rice_win.json"),

                    new TextureAsset("collect-salmon-reset_base", "sheets/animationSheets/collect/collect-salmon_reset.json"),
                    new TextureAsset("collect-salmon-win_base", "sheets/animationSheets/collect/collect-salmon_win.json"),
                    new TextureAsset("collect-soy-reset_base", "sheets/animationSheets/collect/collect-soy_reset.json"),
                    new TextureAsset("collect-soy-win_base", "sheets/animationSheets/collect/collect-soy_win.json"),


                    new TextureAsset("kamisabi-logo-win-loop-base", "sheets/animationSheets/collect/kamisabi-logo-win-loop.json"),


                    new TextureAsset("ka-fly-infromempty-base", "sheets/animationSheets/collect/ka-infromempty.json"),
                    new TextureAsset("ka-fly-preshoot-base", "sheets/animationSheets/collect/ka-preshoot.json"),
                    new TextureAsset("ka-fly-reset-base", "sheets/animationSheets/collect/ka-reset.json"),
                    new TextureAsset("ka-fly-win-base", "sheets/animationSheets/collect/ka-win.json"),


                    new TextureAsset("mi-fly-infromempty-base", "sheets/animationSheets/collect/mi-infromempty.json"),
                    new TextureAsset("mi-fly-preshoot-base", "sheets/animationSheets/collect/mi-preshoot.json"),
                    new TextureAsset("mi-fly-reset-base", "sheets/animationSheets/collect/mi-reset.json"),
                    new TextureAsset("mi-fly-win-base", "sheets/animationSheets/collect/mi-win.json"),


                    new TextureAsset("sabi-fly-infromempty-base", "sheets/animationSheets/collect/sabi-infromempty.json"),
                    new TextureAsset("sabi-fly-preshoot-base", "sheets/animationSheets/collect/sabi-preshoot.json"),
                    new TextureAsset("sabi-fly-reset-base", "sheets/animationSheets/collect/sabi-reset.json"),
                    new TextureAsset("sabi-fly-win-base", "sheets/animationSheets/collect/sabi-win.json"),

                    new TextureAsset("ninjaWildJump-base", "sheets/animationSheets/wild/wild1.json"),
                    new TextureAsset("ninjaWildSplit-base", "sheets/animationSheets/wild/wild2.json"),
                    new TextureAsset("ninjaWildLand-base", "sheets/animationSheets/wild/wild3.json"),
                    new TextureAsset("whitePouff-base", "sheets/animationSheets/wild/white-pouff.json"),
                    new TextureAsset("ninjaWildSplashScreen-base", "sheets/animationSheets/wild/wild-attention.json"),



                    new TextureAsset("KAMISABI_ANIMATION_KA-base", "sheets/animationSheets/kamisabiSplash/kamisabi-ka.json"),
                    new TextureAsset("KAMISABI_ANIMATION_MI-base", "sheets/animationSheets/kamisabiSplash/kamisabi-mi.json"),
                    new TextureAsset("KAMISABI_ANIMATION_SABI-base", "sheets/animationSheets/kamisabiSplash/kamisabi-sabi.json"),
                    new TextureAsset("KAMISABI_BACKGROUND_ANIMATION-base", "sheets/animationSheets/kamisabiSplash/kamisabi-speedlines.json"),
                    new TextureAsset("KAMISABI_TEXT_ANIMATION-base", "sheets/animationSheets/kamisabiSplash/kamisabi-text.json"),

                    new TextureAsset("black_hole-base", "sheets/animationSheets/win/black_hole.json"),

                    new TextureAsset("ring_land-base", "sheets/animationSheets/freespin/ring_land.json"),
                    new TextureAsset("sushi-transform-base", "sheets/animationSheets/freespin/sushi-transform.json"),
                    new TextureAsset("ten-fs-base", "sheets/animationSheets/freespin/ten-fs.json"),
                    new TextureAsset("banner-left-base", "sheets/animationSheets/freespin/banner-left.json"),
                    new TextureAsset("banner-right-base", "sheets/animationSheets/freespin/banner-right.json"),
                    new TextureAsset("meter-sym-attention-base", "sheets/animationSheets/freespin/meter-sym-attention.json"),
                    new TextureAsset("sushi-transform-meter-base", "sheets/animationSheets/freespin/sushi-transform-meter.json"),

                    new TextureAsset("smoke-idle-base", "sheets/animationSheets/background/smoke-idle.json"),


                ],
                animations:{
                    [KitchenDramaSushiManiaGameAssets.SMOKE]: "smoke_000",
                    [KitchenDramaSushiManiaGameAssets.BLACK_HOLE_ANIMATION]: "Comp 2_000",
                    [KitchenDramaSushiManiaGameAssets.KAMISABI_BACKGROUND_ANIMATION]: "speedlines_0",
                    [KitchenDramaSushiManiaGameAssets.KAMISABI_TEXT_ANIMATION]: "kamisabi-text_0",
                    [KitchenDramaSushiManiaGameAssets.KAMISABI_ANIMATION_KA]: "ka_0",
                    [KitchenDramaSushiManiaGameAssets.KAMISABI_ANIMATION_MI]: "mi_0",
                    [KitchenDramaSushiManiaGameAssets.KAMISABI_ANIMATION_SABI]: "sabi_0",
                    "ninjaWildJump":"wild-part1_0",
                    "ninjaWildSplit":"wild-part2_0",
                    "ninjaWildLand":"wild-part3_0",
                    "ninjaWildSplashScreen":"bruberry-sprittu_0",
                    "whitePouff":"white-pouff_0",

                    "sushiLogo":"wild-sushi-sign_",
                    "glimmer":"glimmer-win_",
                    "kamisabiLogo":"kamisabi-sign-win-loop_",

                    "salmon_reset":"collect-salmon_reset_0",
                    "salmon_collect":"collect-salmon_win_0",
                    "rice_reset":"collect-rice_reset_0",
                    "rice_collect":"collect-rice_win_0",
                    "soy_reset":"collect-soy_reset_0",
                    "soy_collect":"collect-soy_win_0",

                    "ka_reset":"ka-reset_0",
                    "ka_collect":"ka-win_0",
                    "ka_win":"ka-preshoot_0",
                    "ka_winReset":"ka-infromempty_0",

                    "mi_reset":"mi-reset_0",
                    "mi_collect":"mi-win_0",
                    "mi_win":"mi-preshoot_0",
                    "mi_winReset":"mi-infromempty_0",

                    "sabi_reset":"sabi-reset_0",
                    "sabi_collect":"sabi-win_0",
                    "sabi_win":"sabi-preshoot_0",
                    "sabi_winReset":"sabi-infromempty_0",

                    "L1_jump":"Mayo_00",
                    "L2_jump":"soy_00",
                    "L3_jump":"pepper_00",
                    "L4_jump":"salt_00",
                    "M1_jump":"Salmon_00",
                    "M2_jump":"radish_00",
                    "M3_jump":"ginger_00",
                    "M4_jump":"Rice_00",
                    "W_jump":"Wild_00",
                    "W2_jump":"Wild2_00",
                    "W3_jump":"Wild Sushi_00",


                    "sushiTransform":"sushi-tranform_00",
                    "ring_land":"ring_0",
                    [KitchenDramaSushiManiaGameAssets.FS_NUMBER_ANIM]:"10_0",
                    [KitchenDramaSushiManiaGameAssets.BANNER_LEFT]:"left_0",
                    [KitchenDramaSushiManiaGameAssets.BANNER_RIGHT]:"right_0",
                    [KitchenDramaSushiManiaGameAssets.FS_SUSHI_METER_ATTENTION]:"meter-sym-attention_00",
                    [KitchenDramaSushiManiaGameAssets.FS_SUSHI_METER_TRANSFORM_SYMBOL]:"Sushi-transform_00",

                    [KitchenDramaSushiManiaGameAssets.KAMISABI_MID_MELT]:"char1_melt_000",
                    [KitchenDramaSushiManiaGameAssets.KAMISABI_LOW_MELT]:"low_melt_000",
                    [KitchenDramaSushiManiaGameAssets.KAMISABI_MAYO_MELT]:"mayo_melt_000",
                    [KitchenDramaSushiManiaGameAssets.KAMISABI_SPLASH]:"splash_000",

                    "klink":"klink0",
                    "swoosh1":"s1_0",
                    "swoosh2":"s2_0",
                    "swoosh3":"s3_0",
                    "swoosh4":"s4_0",

       /*             "bigWin":"BW_0",
                    "bigWinNextLevel":"BW_up_0",*/

                    "bwIntro" : "BW_0",
                    "bwNextLevel" : "BW_up_0"


                }
            }
        ]
    };




}